<template>
  <div class="stage">
    <div class="blobs" aria-hidden="true">
      <span class="blob b1"></span>
      <span class="blob b2"></span>
      <span class="blob b3"></span>
      <span class="blob b4"></span>
    </div>

    <div class="stage-inner">
      <p class="kicker">Rainbow Manager</p>
      <h1>{{ t('FAQ') }}</h1>
      <p class="lead">{{ t('faqLead') }}</p>

      <article class="card">
        <h2>{{ t('howInstallIOSTitle') }}</h2>
        <p>
          {{ t('openAppInBrowserTitle') }} <strong>Safari</strong>. {{ t('pressBtnTitle') }}
          <em>Share</em> ({{ t('squareIconTitle') }}). {{ t('selectItem') }}
          <em>{{ t('addToHomeScreenTitle') }}</em
          >. {{ t('confirmAndClickTitle') }} <em>{{ t('addTitle') }}</em
          >.
          {{ t('appWillAppearText') }}
        </p>
        <div v-if="language === 'ru'" class="faq-photos">
          <figure>
            <span>1</span>
            <img src="../../../assets/menu-ios.jpg" alt="" />
          </figure>
          <figure>
            <span>2</span>
            <img src="../../../assets/install-ios-ru.jpg" alt="" />
          </figure>
          <figure>
            <span>3</span>
            <img src="../../../assets/confirm-ios-ru.jpg" alt="" />
          </figure>
        </div>
        <div v-if="language === 'en'" class="faq-photos">
          <figure>
            <span>1</span>
            <img src="../../../assets/menu-ios-en.jpg" alt="" />
          </figure>
          <figure>
            <span>2</span>
            <img src="../../../assets/install-ios-en.jpg" alt="" />
          </figure>
          <figure>
            <span>3</span>
            <img src="../../../assets/confirm-ios-en.jpg" alt="" />
          </figure>
        </div>
      </article>

      <article class="card">
        <h2>{{ t('howInstallAndroidTitle') }}</h2>
        <p>
          {{ t('openAppInBrowserTitle') }} <strong>Chrome</strong>. {{ t('pressBtnTitle') }}
          <em>⋮</em> ({{ t('threeDotsText') }}). {{ t('selectItem') }}
          <em>{{ t('addToHomeScreenTitle') }}</em
          >. {{ t('confirmAndClickTitle') }} <em>{{ t('addTitle') }}</em
          >.
          {{ t('appWillAppearText') }}
        </p>
        <div v-if="language === 'ru'" class="faq-photos">
          <figure>
            <span>1</span>
            <img src="../../../assets/menu-android.jpg" alt="" />
          </figure>
          <figure>
            <span>2</span>
            <img src="../../../assets/install-ru.jpg" alt="" />
          </figure>
          <figure>
            <span>3</span>
            <img src="../../../assets/confirm-ru.jpg" alt="" />
          </figure>
        </div>
        <div v-if="language === 'en'" class="faq-photos">
          <figure>
            <span>1</span>
            <img src="../../../assets/menu-android.jpg" alt="" />
          </figure>
          <figure>
            <span>2</span>
            <img src="../../../assets/install-en.jpg" alt="" />
          </figure>
          <figure>
            <span>3</span>
            <img src="../../../assets/confirm-en.jpg" alt="" />
          </figure>
        </div>
      </article>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const language = computed(() => store.getters['language/language']);

    return {
      t,
      language,
    };
  },
});
</script>
<style scoped lang="scss">
.stage {
  position: relative;
  isolation: isolate;
  min-height: 100%;
  display: flex;
  justify-content: center;
  padding: 32px 28px 64px;
  color: #f6f3ee;
  background: #141018;
}

.blobs {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.55;
  animation: blob-drift 22s ease-in-out infinite;
}

.b1 {
  width: 48vw;
  height: 48vw;
  left: -8%;
  top: -18%;
  background: #fa496e;
  animation-duration: 18s;
}

.b2 {
  width: 42vw;
  height: 42vw;
  right: -10%;
  top: 8%;
  background: #a67eff;
  animation-duration: 24s;
  animation-direction: reverse;
}

.b3 {
  width: 38vw;
  height: 38vw;
  left: 18%;
  bottom: -16%;
  background: #52dbff;
  animation-duration: 20s;
}

.b4 {
  width: 28vw;
  height: 28vw;
  right: 18%;
  bottom: 8%;
  background: #a67eff;
  opacity: 0.7;
  animation-duration: 16s;
  animation-direction: reverse;
}

.stage-inner {
  position: relative;
  z-index: 1;
  width: min(760px, 100%);
  text-align: center;
}

.kicker {
  margin: 0 0 16px;
  font-size: 11px;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: rgba(246, 243, 238, 0.7);
}

h1 {
  margin: 0 auto 12px;
  font-size: clamp(2.2rem, 6vw, 3.4rem);
  font-weight: 600;
  line-height: 1.05;
  letter-spacing: -0.04em;
}

.lead {
  margin: 0 auto 28px;
  max-width: 36ch;
  font-size: 1.05rem;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.78);
}

.card {
  margin: 0 0 16px;
  padding: 24px;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 20px;
  background: rgba(20, 16, 24, 0.28);
  text-align: left;
}

.card h2 {
  margin: 0 0 10px;
  font-size: clamp(1.2rem, 2.4vw, 1.5rem);
  font-weight: 600;
  letter-spacing: -0.03em;
}

.card p {
  margin: 0 0 18px;
  font-size: 15px;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.78);
}

.card strong,
.card em {
  color: #f6f3ee;
  font-style: normal;
  font-weight: 600;
}

.faq-photos {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.faq-photos figure {
  position: relative;
  margin: 0;
  overflow: hidden;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 16px;
  background: rgba(20, 16, 24, 0.48);
}

.faq-photos img {
  display: block;
  width: 100%;
  height: auto;
}

.faq-photos span {
  position: absolute;
  left: 8px;
  top: 8px;
  min-width: 22px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.08em;
  color: #f6f3ee;
  background: rgba(20, 16, 24, 0.58);
  backdrop-filter: blur(8px);
}

@keyframes blob-drift {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(5%, 7%) scale(1.08);
  }
}

@media (max-width: 700px) {
  .stage {
    padding: 20px 18px 40px;
  }

  .card {
    padding: 20px 16px;
  }

  .faq-photos {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .blob {
    animation: none;
  }
}
</style>
